import PropTypes from "prop-types";
import ProgrammesCard from "./ProgrammesCard";

ProgrammesList.propTypes = {
  products: PropTypes.array.isRequired,
};

export default function ProgrammesList({ programmes }) {
  return (
    <div className="row">
      {programmes.map((programm) => (
        <div className="col-12 col-md-4 mt-4">
          <ProgrammesCard programm={programm} />
        </div>
      ))}
    </div>
  );
}
